import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service des droits
 */
@Injectable({
  providedIn: 'root'
})
export class DroitService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Lister les droits d'un utilisateur par fournisseur
     * @param login
     * @param codeFournisseur
     */
    listerDroitsUtilisateur(login: string, codeFournisseur: string) {
        let httpParams = new HttpParams().set('Login', login).set('Code', codeFournisseur);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/droit/listerdroitsutilisateur`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Lister les r�les d'un fournisseur
     * @param codeFournisseur
     */
    listerRolesFournisseur(codeFournisseur: string) {
        let httpParams = new HttpParams().set('Code', codeFournisseur);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/droit/listerrolesfournisseur`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Assigner les droits (r�les) d'un utilisateur par fournisseur
     * @param codeFournisseur
     * @param login
     * @param codesRoles
     */
    assignerDroitsFournisseurUtilisateur(codeFournisseur: string, login: string, codesRoles: string[]) {
        let model = {
            CodeFournisseur: codeFournisseur,
            Login: login,
            CodesRoles: codesRoles
        };
        return this.http.post<any>(`api/droit/assignerdroitsfournisseurutilisateur`, model).pipe(map(retour => { return retour; }));
    }
}
